import { render, staticRenderFns } from "./BusinessCardRotator.vue?vue&type=template&id=6088accf&scoped=true"
import script from "./BusinessCardRotator.vue?vue&type=script&lang=js"
export * from "./BusinessCardRotator.vue?vue&type=script&lang=js"
import style0 from "./BusinessCardRotator.vue?vue&type=style&index=0&id=6088accf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6088accf",
  null
  
)

export default component.exports